import { Navigate } from '@sorare/routing';
import { ANY_SPORT_ONBOARDING_TUTORIAL } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

export const OnboardingPage = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_ONBOARDING_TUTORIAL)}
      replace
    />
  );
};

export default OnboardingPage;
